import http from '@/api/http'
import { protectedRequest } from '@/api/protectedRequest'
import { API_BASE_URL } from '@/config/env'
import { mapCategory } from '@/entities/category/model/mapCategory'

function hasRestaurantCatalogApi() {
  return Boolean(API_BASE_URL)
}

function unwrapCategoryList(body) {
  const list = body?.data ?? body
  if (Array.isArray(list)) {
    return list
  }
  if (Array.isArray(list?.items)) {
    return list.items
  }
  return []
}

export async function fetchRestaurantCategoriesApi({
  limit = 50,
  skip = 0,
  filter = { is_active: true },
  sort = { title: 1 },
} = {}) {
  if (!hasRestaurantCatalogApi()) {
    return []
  }

  const body = await protectedRequest(() =>
    http.post('/restaurant/categories', {
      limit: Math.max(1, Number(limit) || 50),
      skip: Math.max(0, Number(skip) || 0),
      filter,
      sort,
    }),
  )

  return unwrapCategoryList(body).map(mapCategory).filter((item) => item.id)
}

export async function createRestaurantCategoryApi({ title, isActive = true } = {}) {
  if (!hasRestaurantCatalogApi()) {
    return null
  }

  const body = await protectedRequest(() =>
    http.post('/restaurant/category', {
      title: String(title ?? '').trim(),
      is_active: isActive,
    }),
  )

  return mapCategory(body?.data ?? body)
}
